<template>
  <v-tabs>
    <v-tab>НЕФТЕБАЗА</v-tab>
    <v-tab>ОСТАТКИ</v-tab>
    <v-tab>ДОБАВЛЕННЫЕ НЕФТЕПРОДУКТЫ</v-tab>
    <v-tab>СПИСАННЫЕ НЕФТЕПРОДУКТЫ</v-tab>
    <v-tab-item>
      <oil-form v-if='loading'
                :title='title'
                :createForm='!id'
                :keys='keys'
                :items='terminal'
                :formCallback='formCallback'
      >
        <template v-slot:Products='{input}'>

          <v-combobox v-model='terminal.Products'
                      :items='products'
                      label='Выбрать товар'
                      multiple
                      item-value='Id'
                      :disabled='!input.isEdit'
                      item-text='Name'
                      :rules="[requiredProduct]"
                      return-object
                      @input='changeProduct'
                      dense
                      outlined
                      small-chips
          />
          <v-dialog
              v-model='dialog'
              :max-width='500'
              persistent
          >

            <v-card>
              <v-card-title class='headline'>
                create product
              </v-card-title>
              <v-card-text>
                other info
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    @click='dialog = false'
                    color='green darken-1'
                    text
                >
                  Отменить
                </v-btn>
                <v-btn
                    @click='dialog = false'
                    color='green darken-1'
                    text
                >
                  Подтвердить
                </v-btn>
              </v-card-actions>
            </v-card>

          </v-dialog>
        </template>


      </oil-form>
    </v-tab-item>
    <v-tab-item>
      <v-container v-if='id'>
        <v-text-field
            v-model='search.product'
            append-icon='mdi-magnify'
            label='Поиск'
            outlined
            dense
            hide-details
        ></v-text-field>
        <v-data-table
            class='mt-5'
            :search='search.product'
            :items='terminal.Products'
            :headers="[
                          {text:'Название товара',value:'Name'},
                          {text:'Количество в тоннах',value:'Tons'}
                      ]"

        />
      </v-container>
      <v-container v-else>
        <span>Нету Товаров</span>
      </v-container>
      <v-container v-if='id && terminalLogs.length'>
        <v-card-text>Добавление нефтепродукты</v-card-text>
        <TerminalLogTable
            :items='terminalLogs.filter(terl => !terl.IsWriteOff)'
        />
        <v-divider/>
        <v-card-text>Списание нефтепродукты</v-card-text>
        <TerminalLogTable
            :items='terminalLogs.filter(terl => terminal.IsWriteOff)'
        />
      </v-container>
    </v-tab-item>
    <v-tab-item>
      <v-container v-if='id'>
        <v-row class='my-2'>
          <v-col cols='2'>
            <Modal1
                :products='terminal.Products'
                title='Добавить нефтепродукт'
                color='green'
                :action='accept'
                :IsWriteOff='false'
            />
          </v-col>
        </v-row>


        <v-text-field
            v-model='search.writeOn'
            append-icon='mdi-magnify'
            label='Поиск'
            outlined
            dense
            hide-details
        ></v-text-field>
        <TerminalLogTable
            :search='search.writeOn'
            :items='terminalLogs.filter(terminal => !terminal.IsWriteOff)'
        />
      </v-container>
      <v-container v-else>
        <span>Нету данных</span>
      </v-container>

    </v-tab-item>
    <v-tab-item>
      <v-container v-if='id'>
        <v-row class='my-2'>
          <v-col cols='2'>
            <Modal1
                :products='terminal.Products'
                title='Списать нефтепродукт'
                color='red'
                :action='accept'
                :IsWriteOff='true'
            />

          </v-col>
        </v-row>
        <v-text-field
            v-model='search.writeOf'
            append-icon='mdi-magnify'
            label='Поиск'
            outlined
            dense
            hide-details
        ></v-text-field>
        <TerminalLogTable
            :search='search.writeOf'
            :items='terminalLogs.filter(terminal => terminal.IsWriteOff)'
        />
      </v-container>
      <v-container v-else>
        <span>Нету данных</span>
      </v-container>
    </v-tab-item>
  </v-tabs>

</template>

<script>
import keys from './setting/terminal.json'
import {terminalService} from '@/services/TerminalService'

const {productsService} = require('~/services/ProductsService')

export default {
  props: {
    id: String
  },
  data: () => ({
    keys: keys,
    loading: false,
    dialog: false,
    search: {
      product: '',
      writeOn: '',
      writeOf: ''
    },
    title: 'создать нефтебазу',
    terminal: {
      Name: '',
      Address: '',
      ResponsiblePerson: '',
      ContractNumber: '',
      AppendixNumber: '',
      Date: '',
      Products: [],
      TerminalLogs: [],
      MonthlyRent: '',
      MonthlyRentDate: '',
      Comment: '',
      TelegramGroupId: ''
    },
    products: []
  }),
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    Modal: () => import('@/components/helper/form/oil.delete.modal'),
    Modal1: () => import('./setting/OilModal'),
    TerminalLogTable: () => import('./setting/TerminalLogTable')
  },
  async created() {

    const products = await productsService.getAll()

    this.products = products.data || []
    if (this.id) {
      this.title = 'инфо о нефтебазе'
      const terminal = await terminalService.getById(this.id)
      this.terminal = terminal.data
    }

    this.loading = true
  },
  computed: {
    terminalLogs() {
      const products = this.terminal?.Products
      const allLogs = []
      products?.forEach(product => {
        if (!product?.TerminalLogs) return
        allLogs.push(...product.TerminalLogs)
      })
      return allLogs
    },
    storeType() {
      return this.id ? terminalService.update : terminalService.create
    },
    message(){
      return this.id ? 'нефтебаза удачно изменен' : 'нефтебаза удачно создан'
    }
  },
  methods: {
    requiredProduct(product) {
      return !!product?.length || 'Поле обязательно для ввода'
    },
    getTerminalLogs() {
      return this.terminalLogs.filter(terl => !terl.IsWriteOff)
    },
    async accept(terminalLog) {
      const productId = terminalLog.ProductId

      const product = this.terminal.Products.find(({Id}) => Id === productId)

      if (!product) return

      product.TerminalLogs.push(terminalLog)
      //this.terminal.TerminalLogs.push({...terminalLog})

      await terminalService.update(this.terminal)
    },
    changeProduct(products) {
      if (!products) return
      this.terminal.Products = products.map(product => {
        return {
          ...product
        }
      })
    },
    async formCallback(data, input,form,func) {


      input.isEdit = false

      const response = await this.storeType(data)


      if (!response?.data) {
        input.isEdit = true
        return
      }

      func(this.message)

      await this.$router.push({
        name: 'terminals'
      })

      // if (!this.id) {
      //
      //   // await this.$router.replace({
      //   //   path: `/terminal/${this.terminal.Id}`
      //   // })
      //   // this.title = 'инфо о нефтебазе'
      // }

      // const terminal = await terminalService.getById(this.id)
      // this.terminal = terminal.data
    }
  }
}
</script>
